module.exports = __webpack_public_path__ + "images/error-f4561092d314e5bd9f0774eee31bcba6.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/images/error.png
// module id = ./client/assets/images/error.png
// module chunks = 86